(function () {
    'use strict';

    angular
        .module('spidwebApp')
        .factory('careInstructionService', careInstructionService);

    careInstructionService.$inject = ['axiosService', 'masterdatasCache', 'envService'];

    function careInstructionService(axiosService, masterdatasCache, envService) {

        return {
            getCareInstructions: function (locale) {
                return axiosService
                    .get(
                        envService.getCareInstructionsUrl() +
                            '?' +
                            Object.entries({ locale })
                                .map(([key, val]) => `${key}=${val}`)
                                .join('&'),
                        {
                            withCredentials: true,
                            cache: masterdatasCache,
                            headers: {
                                Accept: 'application/json;charset=UTF-8',
                            },
                        }
                    )
                    .then(function (careInstructions) {
                        return careInstructions.data;
                    });
            }
        };

    }

})();
